// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__QClwY","loader":"Loader_loader__DwtSp","letterJump":"Loader_letterJump__ZlOEl"};